module.exports = __webpack_public_path__ + "img/photos/news/big/01@2x.jpg";